import FormatQuoteRoundedIcon from "@mui/icons-material/FormatQuoteRounded";
import { Box, Typography } from "@mui/joy";

import { LandingSection, LandingContainer } from "../../../LandingLayout";
import { FadeIn } from "~/common/components";

/** Testimonial section with a customer quote */
export const Testimonial = () => {
  return (
    <LandingSection>
      {/* Section title */}
      <LandingContainer size="md" sx={{ textAlign: "center", mb: 6 }}>
        <FadeIn offsetY={20} duration={300} delay={100}>
          <Typography
            sx={{
              fontSize: { xs: "0.75rem", md: "0.875rem" },
              fontWeight: 600,
              textTransform: "uppercase",
              letterSpacing: "0.1em",
              color: "primary.500",
              mb: 1.5,
            }}
          >
            Відгуки
          </Typography>
        </FadeIn>
        <FadeIn offsetY={20} duration={300} delay={200}>
          <Typography
            level="h2"
            sx={{
              fontSize: { xs: "1.5rem", md: "2rem", lg: "2.5rem" },
              fontWeight: 700,
              lineHeight: 1.2,
            }}
          >
            Що кажуть наші клієнти
          </Typography>
        </FadeIn>
      </LandingContainer>

      {/* Testimonial card */}
      <FadeIn offsetY={20} duration={300} delay={300}>
        <Box
          sx={{
            maxWidth: 800,
            mx: "auto",
            bgcolor: "background.level1",
            borderRadius: "lg",
            p: { xs: 3, sm: 4, md: 5 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: 3, md: 4 },
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              border: "2px solid",
              borderColor: "neutral.400",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FormatQuoteRoundedIcon
              sx={{ fontSize: 20, color: "text.primary" }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: { xs: 2, sm: 2.5, md: 4 },
              alignItems: { xs: "center", sm: "flex-start" },
            }}
          >
            <Box
              sx={{
                width: { xs: 64, md: 80 },
                height: { xs: 64, md: 80 },
                borderRadius: "50%",
                overflow: "hidden",
                flexShrink: 0,
              }}
            >
              <img
                src="/founder2.jpg"
                alt="Bohdan Kuzmovych"
                loading="lazy"
                decoding="async"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: { xs: 2, md: 3 },
                textAlign: { xs: "center", sm: "left" },
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "1rem", sm: "1.125rem", md: "1.25rem" },
                  fontWeight: 400,
                  lineHeight: 1.7,
                  color: "text.primary",
                }}
              >
                &ldquo;Платформа Brandly допомогла нам зекономити близько 20
                годин роботи на місяць. Круто, що вона контролює всі наші
                заявки, нагадує про всі запити, дедлайни і відстежує строк дії
                свідоцтв на ТМ. Особливо зручні нагадування в телеграмі про
                зміни в заявках. Дуже рекомендую!&rdquo;
              </Typography>

              <Box>
                <Typography
                  sx={{
                    fontSize: { xs: "1rem", md: "1.125rem" },
                    fontWeight: 700,
                    color: "text.primary",
                  }}
                >
                  Bohdan Kuzmovych
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "0.875rem", md: "0.938rem" },
                    fontWeight: 400,
                    color: "text.secondary",
                  }}
                >
                  Managing partner Red Lawyers, лідер на ринку ІР
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </FadeIn>
    </LandingSection>
  );
};
